module.exports = __webpack_public_path__ + "features-page-feedback-308cf799a0995698eb4267607833ca3d.jpg";